<template>
  <div class="product-create-content">
    <div
      class="product-create"
    >
      <div
        v-if="productNotFound"
        class="product-not-found"
      >
        <div class="not-found-icon">
          <img
            :src="`${$root.cdnUrl}assets/not-found-icon.svg`"
            alt="Ürün bulunamadı"
          >
        </div>
        <h4 class="not-found-title">
          Ürün Bulunamadı
        </h4>
        <p class="not-found-message">
          Okuttuğunuz barkoda ait ürün sistemde bulunamadı. Lütfen farklı bir barkod okutarak tekrar deneyiniz.
        </p>
        <button
          class="btn btn-trendyol"
          @click="readBarcode"
          type="button"
        >
          TEKRAR BARKOD OKUT
        </button>
        <button
          class="btn btn-link"
          @click="cancelProduct"
          type="button"
        >
          ÜRÜN LİSTESİNE DÖN
        </button>
      </div>
      <div v-else-if="!isCompleted">
        <div class="product-item">
          <div class="product-image">
            <img
              :src="productImage"
              width="100%"
              alt="product image"
            >
          </div>
          <div class="product-content">
            <div class="product-name">
              {{ product.title }}
            </div>
            <ul class="product-attributes">
              <li><span>Barkod:</span> {{ product.barcode }}</li>
              <li><span>Renk:</span> {{ getColor }}</li>
              <li><span>Beden:</span> {{ getSize }}</li>
            </ul>
          </div>
        </div>
        <p
          class="product-exists"
          v-if="product.exist"
        >
          Okuttuğunuz barkod, ürün listenizde bulunmaktadır!
        </p>
        <form
          class="product-form"
          novalidate
          @submit.prevent="createProductBarcode"
        >
          <div class="product-form-container">
            <div class="form-group">
              <label>
                SATICI STOK KODU
              </label>
              <div>
                <input
                  type="text"
                  class="form-control stock-code-input"
                  v-model="formData.stockCode"
                  :class="{'is-invalid' : errors.has('stockCode')}"
                  data-vv-as="Satıcı stok kodu"
                  name="stockCode"
                  :disabled="product.exist"
                >
                <div class="invalid-feedback">
                  {{ errors.first('stockCode') }}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>
                STOK MİKTARI
              </label>
              <div>
                <GInputQuantity
                  v-model="formData.quantity"
                  v-validate="{ required: true, configMax: true }"
                  :class="{'is-invalid' : errors.has('quantity')}"
                  data-vv-as="Stok miktarı"
                  name="quantity"
                  :disabled="product.exist"
                />
                <div class="invalid-feedback">
                  {{ errors.first('quantity') }}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>
                TRENDYOL SATIŞ FİYATI
              </label>
              <div>
                <GInputPrice
                  v-model="formData.salePrice"
                  v-validate="{ required: true, maxSalePrice: formData.salePrice }"
                  :class="{'is-invalid' : errors.has('salePrice')}"
                  data-vv-as="Trendyol Satış Fiyatı"
                  name="salePrice"
                  :disabled="product.exist"
                  @focus="setCaretPosition"
                />
                <div class="invalid-feedback">
                  {{ errors.first('salePrice') }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="product.exist">
            <button
              class="btn btn-secondary"
              type="button"
              @click="readBarcode"
            >
              BARKOD OKUTMAYA DEVAM ET
            </button>
            <button
              class="btn btn-trendyol"
              type="button"
              @click="cancelProduct"
            >
              ÜRÜN LİSTEME DÖN
            </button>
          </div>
          <div v-else="">
            <button
              class="btn btn-secondary"
              type="button"
              @click="cancelProduct"
            >
              SEÇMEKTEN VAZGEÇ
            </button>
            <button
              v-if="showApproveButton"
              class="btn btn-trendyol"
              type="submit"
            >
              ONAYLA VE SATIŞA BAŞLA!
            </button>
          </div>
        </form>
      </div>
      <div
        v-else=""
        class="product-create-complete"
      >
        <div>
          <img :src="`${$root.cdnUrl}assets/icon-complete.svg`">
        </div>
        <div>
          <h4 class="complete-title">
            Ürününüz başarılı bir şekilde <br> ürün listenize eklenmiştir!
          </h4>
          <div class="complete-subtitle">
            Ürününüz belge onay sürecine takılmadıysa sistem tarafından otomatik yayına açılacaktır.
          </div>
        </div>

        <button
          class="btn btn-trendyol"
          @click="cancelProduct"
          type="button"
        >
          ÜRÜN LİSTESİNE DÖN
        </button>
        <button
          class="btn btn-link"
          @click="readBarcode"
          type="button"
        >
          BARKOD OKUTMAYA DEVAM ET
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import service from '@/services/singleProduct';
import mobile from '@/utils/mobile';
import InputMask from '@/directives/InputMask';
import GInputPrice from '@trendyol-js/grace/core/GInputPrice';
import GInputQuantity from '@/components/GInputQuantity';
export default {
  name: 'ProductDetail',
  components: { GInputQuantity, GInputPrice },
  data () {
    return {
      product: {},
      formData: {
        salePrice: 0,
      },
      isCompleted: false,
      showApproveButton: false,
      productNotFound: false,
      priceDecimalMask: 'priceDecimalGroup',
    };
  },
  directives: {
    mask: InputMask,
  },
  computed: {
    isStoreBaseEnabled () {
      return this.$route.query?.storeBaseEnabled;
    },
    getColor () {
      if (this.product.color) {
        return this.product.color;
      }
      if (this.product.productAttributes && this.product.productAttributes.length) {
        const attribute = this.product.productAttributes.filter(item => item.name.toLowerCase() === 'renk')[0];
        return attribute ? (attribute.customValue || attribute.valueName) : '---';
      }
      return '---';
    },
    getSize () {
      if (this.product.size) {
        return this.product.size;
      }
      if (this.product.productAttributes && this.product.productAttributes.length) {
        const attribute = this.product.productAttributes.filter(item => item.name.toLowerCase() === 'beden')[0];
        return attribute ? (attribute.customValue || attribute.valueName) : '---';
      }
      return '---';
    },
    productImage () {
      const images = this.product.images;
      let image = images && images.length !== 0 ? images[0].originalImageUrl : `${this.$root.cdnUrl}/assets/default.jpg`;
      if (image.search('cdn.dsmcdn.com') > -1) {
        const ext = image.split('.').pop();
        image = image.search('_org_') < 0 ? image.replace(`.${ext}`, `_org_zoom.${ext}`) : image;
        image = image.search('_org_zoom') > -1 ? image.replace(/_org_zoom/gi, '_org_icon') : image;
      }
      return image;
    },
  },
  methods: {
    async getByBarcode () {
      const barcode = this.$route.query.barcode;
      try {
        const product = await service.getByBarcode(barcode);
        this.showApproveButton = true;
        this.productNotFound = false;

        this.product = product.content[0];
        if (this.product.exist) {
          this.formData = {
            quantity: 0,
            salePrice: 0,
            stockCode: '',
          };
        }
      } catch (e) {
        this.productNotFound = true;
        this.showApproveButton = false;
      }
    },
    async validate () {
      const validateResult = await this.$validator.validateAll();
      return validateResult;
    },
    async createProductBarcode () {
      const validateResult = await this.validate();
      if (validateResult) {
        const item = this.product;
        const data = {};
        data.barcode = item.barcode;
        data.title = item.title;
        data.productMainId = item.productMainId;
        data.brandId = item.brandId;
        data.categoryId = item.categoryId;
        data.description = (item.description === '' ? item.title : item.description);
        data.currencyType = 'TRY';
        data.stockCode = this.formData.stockCode;
        data.quantity = parseInt(this.formData.quantity, 10);
        data.listPrice = parseFloat(this.formData.salePrice);
        data.salePrice = parseFloat(this.formData.salePrice);
        data.vatRate = item.vatRate;
        data.cargoCompanyId = item.cargoCompanyId;
        data.returningAddressId = item.returningAddressId;
        data.businessUnitId = item?.businessUnit?.id;
        data.images = item.images ? item.images.map(image => ({
          url: image.originalImageUrl.replace(/_org_icon/gi, ''),
        })) : null;
        data.attributes = item.productAttributes ? item.productAttributes.map(attr => ({
          attributeId: attr.id,
          attributeValueId: attr.valueId ? attr.valueId : null,
          customAttributeValue: !attr.valueId ? attr.customValue : null,
        })) : null;

        await service.createProduct(data);
        this.isCompleted = true;
      }
    },
    cancelProduct () {
      mobile.navigationNavigate({
        pageName: 'ProductListV2',
      });
    },
    readBarcode () {
      this.isCompleted = false;
      this.productNotFound = false;
      this.showApproveButton = false;
      this.product = {};
      this.formData = {
        salePrice: 0,
      };
      mobile.openBarcodePage();
    },
    setCaretPosition (e) {
      const oField = e.target;
      const iCaretPos = oField.value.length - 2;

      setTimeout(() => {
        oField.selectionStart = iCaretPos;
        oField.selectionEnd = iCaretPos;
      }, 50);
    },
  },
  async created () {
    await this.getByBarcode();
  },
};

</script>
<style lang="scss" scoped>

  .product-create-content {
    background-color: #ffffff;
    height: calc(100vh);
    overflow: hidden;
    overflow-y: auto;

    .product-create {
      padding: 0 15px;

      .product-item {
        padding: 20px 0;
        overflow: hidden;
        display: flex;

        &:last-child {
          border-bottom: 0;
        }
        .product-content {
          flex: 1;
          padding-left: 15px;

          .product-name {
            font-size: 13px;
            font-weight: 500;
            color: #273142;
            height: 50px;
            line-height: 1.4;
            overflow: hidden;
          }

          .product-attributes {
            list-style: none;
            margin: 0;
            padding: 0;
            font-size: 13px;

            li {
              color: #273142;
              margin-bottom: 3px;

              span {
                color: #95a1b5;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
        .product-image {
          flex: 1;
          max-width: 65px;
          max-height: 100%;
          overflow: hidden;

          img {
            width: 100%;
          }
        }
      }

      .product-form {
        position: relative;
        padding: 20px 0;

        &:before {
          content: '';
          display: block;
          position: absolute;
          border-top: 2px solid #dee0eb;
          top: 0;
          left: -15px;
          right: -15px;
        }

        .form-group {
          padding-bottom: 20px;
          position: relative;

          label {
            font-size: 14px;
            color: #6e7787;
            margin-bottom: 5px;
            display: block;
          }

          .form-control {
            height: 40px;
            text-align: right;
            padding: 0 11px;

            &.stock-code-input {
              text-align: left;
            }

            &:disabled {
              background-color: #e9ecef;
              opacity: 1;
            }

            &.is-invalid {
              border-color: #dc3545;
            }
          }

          .invalid-feedback {
            width: 100%;
            margin-top: .25rem;
            font-size: 80%;
            color: #dc3545;
            text-align: right;
          }

          &:last-child {
            margin-bottom: 40px;
          }
        }
      }
    }

    .product-create-complete {
      text-align: center;
      padding: 50px 0;
      font-size: 12px;

      .complete-title {
        font-size: 18px;
        font-weight: 500;
        color: #0bc15c;
        margin-bottom: 30px;
      }
      .complete-subtitle{
        color: #856404;
        background-color: #fff3cd;
        padding: .75rem 1.25rem;
        margin-bottom: 50px;
        border: 1px solid #ffeeba;
        border-radius: .25rem;
      }
    }

    .product-not-found {
      text-align: center;
      padding: 50px 15px;

      .not-found-icon {
        margin-bottom: 30px;
        img {
          width: 120px;
          height: 120px;
        }
      }

      .not-found-title {
        font-size: 20px;
        font-weight: 600;
        color: #273142;
        margin-bottom: 15px;
      }

      .not-found-message {
        font-size: 14px;
        color: #6e7787;
        line-height: 1.5;
        margin-bottom: 40px;
        padding: 0 20px;
      }
    }

    .btn-secondary {
      margin-bottom: 15px;
    }

    .btn-link {
      margin-top: 15px;
    }

    .product-exists{
      color: #856404;
      background-color: #fff3cd;
      padding: .75rem 1.25rem;
      border: 1px solid #ffeeba;
      border-radius: .25rem;
      font-size: 12px;
    }
    ::v-deep .g-input .body .g-field-wrapper .content {
      border-radius: 4px;
      border: solid 1px #afbbca;
      height: 40px;
      input {
        font-size: 1rem !important;
      }
    }
  }
</style>
